import type React from 'react'

interface FullPageLoaderProps {
    message?: string
}

const FullPageLoader: React.FC<FullPageLoaderProps> = ({ message = 'Initializing Application...' }) => {
    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 text-white">
            <div className="flex flex-col items-center gap-4">
                <div className="h-12 w-12 animate-spin rounded-full border-4 border-blue-500 border-t-transparent"></div>
                <p className="text-lg font-medium animate-pulse">{message}</p>
            </div>
        </div>
    )
}

export default FullPageLoader
